// DO NOT EDIT -- generated from fs/services/pie/funnels.proto

import { BaselineDirection, IssueStatus } from './spotlight.proto';
import * as metrics from '../../api/metrics';
import * as protobuf from '../../../google/protobuf';
import * as search_settings from '../search-settings';
import * as segment from '../../api/segment';
import * as visualizationsettings from '../search-settings/visualizationsettings';

export namespace FunnelServicePublic {

  export const GetFunnelsEndpoint = "/grpc/pie.FunnelServicePublic/GetFunnels";
  export function GetFunnels(sender: (req: GetFunnelsRequest, endpoint: string) => Promise<GetFunnelsResponse>, req: GetFunnelsRequest): { promise: () => Promise<GetFunnelsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetFunnelsEndpoint),
      endpoint: GetFunnelsEndpoint
    };
  }

  export const SaveFunnelByFunnelIdEndpoint = "/grpc/pie.FunnelServicePublic/SaveFunnelByFunnelId";
  export function SaveFunnelByFunnelId(sender: (req: SaveFunnelByFunnelIdRequest, endpoint: string) => Promise<SaveFunnelByFunnelIdResponse>, req: SaveFunnelByFunnelIdRequest): { promise: () => Promise<SaveFunnelByFunnelIdResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SaveFunnelByFunnelIdEndpoint),
      endpoint: SaveFunnelByFunnelIdEndpoint
    };
  }

  export const DeleteFunnelEndpoint = "/grpc/pie.FunnelServicePublic/DeleteFunnel";
  export function DeleteFunnel(sender: (req: DeleteFunnelRequest, endpoint: string) => Promise<{}>, req: DeleteFunnelRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteFunnelEndpoint),
      endpoint: DeleteFunnelEndpoint
    };
  }

  export const DeleteFunnelsEndpoint = "/grpc/pie.FunnelServicePublic/DeleteFunnels";
  export function DeleteFunnels(sender: (req: DeleteFunnelsRequest, endpoint: string) => Promise<{}>, req: DeleteFunnelsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteFunnelsEndpoint),
      endpoint: DeleteFunnelsEndpoint
    };
  }

  export const ValidateFunnelEndpoint = "/grpc/pie.FunnelServicePublic/ValidateFunnel";
  export function ValidateFunnel(sender: (req: ValidateFunnelRequest, endpoint: string) => Promise<ValidateFunnelResponse>, req: ValidateFunnelRequest): { promise: () => Promise<ValidateFunnelResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ValidateFunnelEndpoint),
      endpoint: ValidateFunnelEndpoint
    };
  }

  export const GetHistoricalStatisticsEndpoint = "/grpc/pie.FunnelServicePublic/GetHistoricalStatistics";
  export function GetHistoricalStatistics(sender: (req: GetHistoricalStatisticsRequest, endpoint: string) => Promise<GetHistoricalStatisticsResponse>, req: GetHistoricalStatisticsRequest): { promise: () => Promise<GetHistoricalStatisticsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetHistoricalStatisticsEndpoint),
      endpoint: GetHistoricalStatisticsEndpoint
    };
  }

  export const GetLatestFunnelStatisticEndpoint = "/grpc/pie.FunnelServicePublic/GetLatestFunnelStatistic";
  export function GetLatestFunnelStatistic(sender: (req: GetLatestFunnelStatisticRequest, endpoint: string) => Promise<GetLatestFunnelStatisticResponse>, req: GetLatestFunnelStatisticRequest): { promise: () => Promise<GetLatestFunnelStatisticResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetLatestFunnelStatisticEndpoint),
      endpoint: GetLatestFunnelStatisticEndpoint
    };
  }

  export const GetBaseInvestigationEndpoint = "/grpc/pie.FunnelServicePublic/GetBaseInvestigation";
  export function GetBaseInvestigation(sender: (req: GetBaseInvestigationRequest, endpoint: string) => Promise<GetBaseInvestigationResponse>, req: GetBaseInvestigationRequest): { promise: () => Promise<GetBaseInvestigationResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetBaseInvestigationEndpoint),
      endpoint: GetBaseInvestigationEndpoint
    };
  }

  export const GetInvestigationPropertiesEndpoint = "/grpc/pie.FunnelServicePublic/GetInvestigationProperties";
  export function GetInvestigationProperties(sender: (req: GetInvestigationPropertiesRequest, endpoint: string) => Promise<GetInvestigationPropertiesResponse>, req: GetInvestigationPropertiesRequest): { promise: () => Promise<GetInvestigationPropertiesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetInvestigationPropertiesEndpoint),
      endpoint: GetInvestigationPropertiesEndpoint
    };
  }

  export const GetInvestigationErrorsEndpoint = "/grpc/pie.FunnelServicePublic/GetInvestigationErrors";
  export function GetInvestigationErrors(sender: (req: GetInvestigationErrorsRequest, endpoint: string) => Promise<GetInvestigationErrorsResponse>, req: GetInvestigationErrorsRequest): { promise: () => Promise<GetInvestigationErrorsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetInvestigationErrorsEndpoint),
      endpoint: GetInvestigationErrorsEndpoint
    };
  }

  export const GetInvestigationEntrancesEndpoint = "/grpc/pie.FunnelServicePublic/GetInvestigationEntrances";
  export function GetInvestigationEntrances(sender: (req: GetInvestigationEntrancesRequest, endpoint: string) => Promise<GetInvestigationEntrancesResponse>, req: GetInvestigationEntrancesRequest): { promise: () => Promise<GetInvestigationEntrancesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetInvestigationEntrancesEndpoint),
      endpoint: GetInvestigationEntrancesEndpoint
    };
  }
}

export namespace FunnelService {

  export const GetFunnelsByP95TtcEndpoint = "/grpc/pie.FunnelService/GetFunnelsByP95Ttc";
  export function GetFunnelsByP95Ttc(sender: (req: GetFunnelsByP95TtcRequest, endpoint: string) => Promise<GetFunnelsByP95TtcResponse>, req: GetFunnelsByP95TtcRequest): { promise: () => Promise<GetFunnelsByP95TtcResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetFunnelsByP95TtcEndpoint),
      endpoint: GetFunnelsByP95TtcEndpoint
    };
  }

  export const MarkFunnelMaybeDirtyEndpoint = "/grpc/pie.FunnelService/MarkFunnelMaybeDirty";
  export function MarkFunnelMaybeDirty(sender: (req: MarkFunnelMaybeDirtyRequest, endpoint: string) => Promise<{}>, req: MarkFunnelMaybeDirtyRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, MarkFunnelMaybeDirtyEndpoint),
      endpoint: MarkFunnelMaybeDirtyEndpoint
    };
  }

  export const GetFunnelByDxIdEndpoint = "/grpc/pie.FunnelService/GetFunnelByDxId";
  export function GetFunnelByDxId(sender: (req: GetFunnelByDxIdRequest, endpoint: string) => Promise<GetFunnelByDxIdResponse>, req: GetFunnelByDxIdRequest): { promise: () => Promise<GetFunnelByDxIdResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetFunnelByDxIdEndpoint),
      endpoint: GetFunnelByDxIdEndpoint
    };
  }
}

export interface Funnel {
  id: string;
  dxFunnelId: string;
  name: string;
  orgId: string;
  eventSequence: segment.EventSequence | null;
  segmentSettings: SegmentSettings | null;
  dxVersion: protobuf.int64;
  aggregation: metrics.UniqueAggregation;
  isDirty: boolean;
  firstComputeStartTime: protobuf.timestamp | null;
}

export interface SegmentSettings {
  segmentSettings: visualizationsettings.SegmentSettings[];
}

export interface GetFunnelsRequest {
  orgId: string;
}

export interface GetFunnelsResponse {
  funnels: Funnel[];
}

export interface GetFunnelsByP95TtcRequest {
  delayStart: protobuf.duration | null;
  delayEnd: protobuf.duration | null;
}

export interface GetFunnelsByP95TtcResponse {
  delayFunnels: GetFunnelsByP95TtcResponse.FunnelDelay[];
}

export namespace GetFunnelsByP95TtcResponse {
  export interface FunnelDelay {
    funnel: Funnel | null;
    delay: protobuf.duration | null;
  }
}

/**
 * TODO: Support saving funnels by events + constraints
 * TODO: Save funnel with a reference to another funnel as a parent
 */
export interface SaveFunnelByFunnelIdRequest {
  orgId: string;
  dxFunnelId: string;
}

export interface SaveFunnelByFunnelIdResponse {
  id: string;
}

export interface DeleteFunnelRequest {
  orgId: string;
  /** NB: Not the dx object id, but the pie id */
  id: string;
}

export interface DeleteFunnelsRequest {
  orgId: string;
  /** NB: Not the dx object id, but the pie id */
  ids: string[];
}

export interface ValidateFunnelRequest {
  orgId: string;
  funnel: search_settings.Funnel | null;
}

export interface ValidateFunnelResponse {
  warnings: string[];
}

export enum FunnelDimensionStatType {
  FUNNEL_DIMENSION_STAT_TYPE_INVALID = 0,
  FUNNEL_DIMENSION_STAT_TYPE_CONVERSION_RATE = 1,
  FUNNEL_DIMENSION_STAT_TYPE_ENTRANCES = 2,
  FUNNEL_DIMENSION_STAT_TYPE_TTC_MS = 3
}

export interface FunnelStatDimensions {
  dimensions: metrics.Dimension[];
  funnelStatDimensions: FunnelStatDimension[];
  type: FunnelDimensionStatType;
}

export interface ZScoreValues {
  zScore: number;
  /** based on the type in the parent */
  value: number;
  lowerBaseline: number;
  upperBaseline: number;
  baselineDirection: BaselineDirection;
}

export interface FunnelStatDimension {
  groups: metrics.DataRowGroup[];
  /** based on the type in the parent */
  zScoreValues: ZScoreValues | null;
  isLikely: boolean;
}

export interface TimeRange {
  startTime: protobuf.timestamp | null;
  endTime: protobuf.timestamp | null;
}

export interface FunnelStatistic {
  id: string;
  computeTimeRange: TimeRange | null;
  trendStep: visualizationsettings.TrendSteps | null;
  zScoreValues: ZScoreValues | null;
  investigationSummary: string;
}

export interface GetHistoricalStatisticsRequest {
  orgId: string;
  funnelId: string;
  timeRange: TimeRange | null;
  /** Optional: if not provided, all trend steps will be returned */
  trendStep: visualizationsettings.TrendSteps | null;
  baselineDirection: BaselineDirection;
}

export interface GetHistoricalStatisticsResponse {
  statistics: FunnelStatistic[];
}

export interface GetLatestFunnelStatisticRequest {
  orgId: string;
  funnelId: string;
}

export interface GetLatestFunnelStatisticResponse {
  statistics: FunnelStatistic[];
}

export interface GetBaseInvestigationRequest {
  orgId: string;
  funnelId: string;
  funnelStatId: string;
}

export interface GetBaseInvestigationResponse {
  funnel: Funnel | null;
  statistic: FunnelStatistic | null;
  noteCount: number;
  assignedTo: string;
  status: IssueStatus;
}

export interface GetInvestigationPropertiesRequest {
  orgId: string;
  funnelId: string;
  funnelStatId: string;
}

export interface GetInvestigationPropertiesResponse {
  statDimensions: FunnelStatDimensions[];
  statistics: FunnelStatistic[];
}

export interface GetInvestigationErrorsRequest {
  orgId: string;
  funnelId: string;
  funnelStatId: string;
}

export interface GetInvestigationErrorsResponse {
  errors: GetInvestigationErrorsResponse.FunnelMetricDimensions[];
}

export namespace GetInvestigationErrorsResponse {
  export interface Dimension {
    group: metrics.DataRowGroup | null;
    percentChange: number;
    likelyFactor: boolean;
    absoluteChange: number;
  }

  export interface FunnelMetricDimensions {
    /** this is a trend metric without the groupId added as a dep */
    metric: search_settings.Metric | null;
    dimensions: GetInvestigationErrorsResponse.Dimension[];
    builtInProperty: metrics.BuiltInDimension;
  }
}

export interface GetInvestigationEntrancesRequest {
  orgId: string;
  funnelId: string;
  funnelStatId: string;
  days: number;
}

export interface GetInvestigationEntrancesResponse {
  entrances: FunnelStatistic[];
  isLikely: boolean;
}

export interface MarkFunnelMaybeDirtyRequest {
  orgId: string;
  funnel: search_settings.FunnelRecord | null;
}

export interface UpdateFunnelTask {
  orgId: string;
  /** pie-object id of the funnel */
  funnelId: string;
}

export interface BackfillFunnelTask {
  funnel: Funnel | null;
  delay: protobuf.duration | null;
}

export interface GetFunnelByDxIdRequest {
  orgId: string;
  funnelId: string;
}

export interface GetFunnelByDxIdResponse {
  funnel: Funnel | null;
}
